import React from 'react';

import { LinkComponentFragment, StrapiImageFragment } from '../../../../graphql.schema';
import SpeechBubble from '../../SpeechBubble';
import StrapiButton from '../../StrapiLink/StrapiButton';

import * as styles from './WhyLearnWithUs.module.scss';

type StrapiWhyLearnWithUsProps = {
  title: string;
  items: {
    itemTitle: string;
    text: string;
    image: StrapiImageFragment;
    button?: LinkComponentFragment;
  }[];
  speech_bubble_1?: string;
  speech_bubble_2?: string;
  caption?: string;
  hasRTL?: boolean;
};

export const StrapiWhyLearnWithUs = ({
  title,
  items,
  speech_bubble_1,
  speech_bubble_2,
  caption,
  hasRTL,
}: StrapiWhyLearnWithUsProps) => {
  return (
    <div className={styles.whyLearnwithuscontainer}>
      <p className={styles.whyLearnTitle}>{title}</p>
      <div className={styles.whyLearn}>
        {items.map((item, index) => (
          <div className={styles.whyLearnCard} key={item.itemTitle}>
            <div className={styles.whyLearnImageContainer}>
              {index === 0 && speech_bubble_1 ? (
                <div className={styles.whyLearnSpeechBubble1}>
                  <SpeechBubble
                    className={styles.speechBubbleText}
                    speechBubbleText={speech_bubble_1}
                    variant="brand-a-light"
                    isReverse={hasRTL}
                  />
                </div>
              ) : null}
              {index === items.length - 1 && speech_bubble_2 ? (
                <div className={styles.whyLearnSpeechBubble2}>
                  <SpeechBubble
                    className={styles.speechBubbleText}
                    speechBubbleText={speech_bubble_2}
                    variant="brand-a-light"
                    isReverse={!hasRTL}
                  />
                </div>
              ) : null}

              <img
                src={item.image.formats?.large?.url || item.image.url}
                srcSet={`
                 ${item.image.formats?.small?.url} 360w,
                 ${item.image.formats?.medium?.url} 768w,
                 ${item.image.formats?.large?.url} 1024w,
                 ${item.image.url} 1920w
               `}
                sizes="(max-width: 600px) 100vw, 
                      (max-width: 1024px) 90vw, 
                      1200px"
                alt={item.image.alternativeText ?? item.image.caption ?? ''}
                className={styles.image}
                width={item.image.width ?? undefined}
                height={item.image.height ?? undefined}
                loading="eager"
              />
            </div>
            <div className={styles.whyLearnContent}>
              <p className={styles.whyLearnContentTitle}>{item.itemTitle}</p>
              <p className={styles.whyLearnContentText}>{item.text}</p>
              {item.button ? <StrapiButton {...item.button} type="secondary" /> : null}
            </div>
          </div>
        ))}
      </div>

      {caption ? (
        <div className={styles.caption}>
          <p>{caption}</p>
        </div>
      ) : null}
    </div>
  );
};
